'use client';

import { ArrowRight } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Stack } from '~/components/Layout/Stack';
import { Link } from '~/components/Link';
// imported from source, not the barrel: that re-exports BpiLinkBannerSection, whose Section imports
// this file back
import { buildBpiHref } from '~/components/marketing/BpiLinkBanner/src/BpiLinkBanner';
// locale-aware: strips the `/en-US` prefix, without which destination detection below silently fails
import { usePathname } from '~/i18n/navigation';
import styles from './NUpCta.module.css';

type NUpCtaProps = {
  isFullWidth?: boolean;
};

const DESTINATION_OVERRIDES: Record<string, string> = { uk: 'UK' };

const NUpCta = ({ isFullWidth = false }: NUpCtaProps) => {
  const t = useTranslations('content');
  const pathname = usePathname() ?? '';
  const segments = pathname.startsWith('/destination/') ? pathname.split('/').filter(Boolean) : [];
  const destination =
    segments[1]
      ?.split('-')
      .map((w) => DESTINATION_OVERRIDES[w] ?? w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ') ?? null;

  const viewAllLink = buildBpiHref({ searchFilter: destination });

  return (
    <Link
      isFullWidth={isFullWidth}
      asButton="tertiary"
      href={viewAllLink}
      className={styles.cta}
      data-ua-click="see_all_trips_dynamic_trip_container"
    >
      <Stack variant="horizontal" space="--by-space-200">
        <span>{t('trips_all')}</span>
        <ArrowRight decorative />
      </Stack>
    </Link>
  );
};

export function NUpCtaMobile({ isFullWidth = false }: NUpCtaProps) {
  return (
    <div className={styles.nUpCtaMobile}>
      <NUpCta isFullWidth={isFullWidth} />
    </div>
  );
}

export function NUpCtaDesktop({ isFullWidth = false }: NUpCtaProps) {
  return (
    <div className={styles.nUpCtaDesktop}>
      <NUpCta isFullWidth={isFullWidth} />
    </div>
  );
}
